import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';

const TypeChoiceOne = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <RadioButtonChecked {...props} ref={ref} />
));

TypeChoiceOne.displayName = 'TypeChoiceOne';

export default TypeChoiceOne;
